<template>
  <!-- 首年/续期费用记录 -->
  <div class="content main-container">
    <loading :isShow="$root.$children[0].isShowLoading" />
    <div class="search-tools">
      <div class="search-box btn3" :class="{'close':!searchMore}">
        <div class="input-item" v-if="$units.superviseShowVal()">
          <span class="label">供应商类型</span>
          <RadioGroup v-model="searchParams.supplierType" @on-change="changeSupplierType">
            <Radio label="">全部</Radio>
            <Radio label="1">保司</Radio>
            <Radio label="2">通道</Radio>
          </RadioGroup>
        </div>
        <div class="input-item" v-if="searchParams.supplierType && $units.superviseShowVal()">
          <span class="label">供应商</span>
          <Select v-model="searchParams.supplierIds" multiple :max-tag-count="4" clearable filterable transfer>
            <Option :value="item.id" v-for="(item, index) in supplierList" :key="index">{{ item.name }}</Option>
          </Select>
        </div>
        <div class="input-item">
          <span class="label" style="width:105px;">交费期次</span>
          <Input v-model="searchParams.commissionPeriods" placeholder="请输入正整数" type="number" @on-change="changeValue('commissionPeriods')" />
        </div>
        <div class="input-item">
          <span class="label">保险公司</span>
          <Select v-model="searchParams.companyCode" clearable filterable transfer>
            <Option v-for="(bean, i) in companyLists" :key="i" :value="bean.code">{{ bean.name }}</Option>
          </Select>
        </div>
        <div class="input-item">
          <span class="label">产品名称</span>
          <Input v-model="searchParams.productName" placeholder="请输入" clearable />
        </div>
        <div class="input-item select-two">
          <Select v-model="searchParams.dateType" :transfer="true" @on-change="changeDateType">
            <Option value="1">投保日期</Option>
            <Option value="2">支付日期</Option>
            <Option value="3">承保日期</Option>
            <Option value="4">生效日期</Option>
          </Select>
          <DatePicker v-model="searchParams.date" type="daterange" split-panels separator=" 至 " :transfer="true"
            placement="bottom" format="yyyy-MM-dd" placeholder="选择日期" @on-change="changeTime"></DatePicker>
        </div>
        <div class="input-item">
          <span class="label">保单号</span>
          <Input v-model="searchParams.policyNo" placeholder="请输入" clearable />
        </div>
        <div class="input-item">
          <span class="label">保单状态</span>
          <Select v-model="searchParams.policyStatusList" clearable multiple>
            <Option value="1">已承保</Option>
            <Option value="-1">已退保</Option>
            <Option value="0">已终止</Option>
          </Select>
        </div>
        <div class="input-item">
          <span class="label">回执状态</span>
          <lzDicSelect v-model="searchParams.receiptStatusList" dicType="RECEIPT_STATUS" :transfer="true" clearable multiple :disabled="searchParams.receiptStatusNull">
          </lzDicSelect>
          <Checkbox v-model="searchParams.receiptStatusNull" class="null" @on-change="changeTypeNull">为空</Checkbox>
        </div>
        <div class="input-item select-two select-two1">
          <Select v-model="searchParams.dateType1" :transfer="true" @on-change="changeDateType1">
            <Option value="1">回执签收日期</Option>
            <Option value="2">回执回销日期</Option>
          </Select>
          <DatePicker v-model="searchParams.date1" type="daterange" split-panels separator=" 至 " :transfer="true"
            placement="bottom" format="yyyy-MM-dd" placeholder="选择日期" @on-change="changeTime1" :disabled="searchParams.isNull"></DatePicker>
            <Checkbox v-model="searchParams.isNull" class="null" @on-change="changeDateNull">为空</Checkbox>
        </div>
        <div class="input-item">
          <span class="label">回访状态</span>
          <lzDicSelect v-model="searchParams.verifyStatusList" dicType="VERIFY_STATUS" :transfer="true" clearable multiple :disabled="searchParams.verifyStatusNull">
          </lzDicSelect>
          <Checkbox v-model="searchParams.verifyStatusNull" class="null" @on-change="changeTypeNull">为空</Checkbox>
        </div>
        <div class="input-item">
          <span class="label">回访日期</span>
          <DatePicker v-model="searchParams.revisitDate" type="daterange" split-panels separator=" 至 " :transfer="true"
            placement="bottom" format="yyyy-MM-dd" placeholder="选择日期" @on-change="changeTime2" :disabled="searchParams.isNull1"></DatePicker>
            <Checkbox v-model="searchParams.isNull1" class="null" @on-change="changeDateNull">为空</Checkbox>
        </div>
        <div class="input-item">
          <span class="label">犹豫止期</span>
          <DatePicker v-model="searchParams.hesitateDate" type="daterange" split-panels separator=" 至 " :transfer="true"
            placement="bottom" format="yyyy-MM-dd" placeholder="选择日期" @on-change="changeTime3" :disabled="searchParams.isNull2"></DatePicker>
            <Checkbox v-model="searchParams.isNull2" class="null" @on-change="changeDateNull">为空</Checkbox>
        </div>
        <div class="input-item">
          <span class="label">退保日期</span>
          <DatePicker v-model="searchParams.refundTime" type="daterange" split-panels separator=" 至 " :transfer="true"
            placement="bottom" format="yyyy-MM-dd" placeholder="选择日期" @on-change="changeTime4" :disabled="searchParams.isNull3"></DatePicker>
            <Checkbox v-model="searchParams.isNull3" class="null" @on-change="changeDateNull">为空</Checkbox>
        </div>
        <div class="input-item">
          <span class="label">上游结算状态</span>
          <Select v-model="searchParams.settlementStatus" transfer placeholder="请选择" clearable>
            <Option value="1">已结算</Option>
            <Option value="0">未结算</Option>
          </Select>
        </div>
        <div class="input-item">
          <span class="label">对账状态</span>
          <Select v-model="searchParams.reconciliationStatus" clearable>
            <Option value="0">未对账</Option>
            <Option value="1">对账正常</Option>
            <Option value="2">对账异常</Option>
            <Option value="3">已对账</Option>
          </Select>
        </div>
        <div class="input-item">
          <span class="label">对账日期</span>
          <DatePicker transfer v-model="searchParams.checkDate" format="yyyy-MM-dd" type="date"  @on-change="searchParams.checkDate = $event"
            placeholder="请选择" :disabled="searchParams.isNull4"></DatePicker>
            <Checkbox v-model="searchParams.isNull4" class="null" @on-change="changeDateNull">为空</Checkbox>
        </div>
        <div class="input-item">
            <span class="label">所属对账单</span>
            <Select v-model="searchParams.reconciliationId" clearable filterable transfer :disabled="searchParams.reconciliationNull">
              <Option :value="item.reconciliationId" v-for="(item, index) in queryList" :key="index" >{{ item.reconciliationName }}</Option>
            </Select>
            <Checkbox v-model="searchParams.reconciliationNull" class="null" @on-change="changeTypeNull">为空</Checkbox>
        </div>
        <div class="input-item" v-if="typeIndex == 2 || typeIndex == 3" key="settleDate">
          <span class="label">结算日期</span>
          <DatePicker transfer v-model="searchParams.settleDate" format="yyyy-MM-dd" type="date"
            placeholder="请选择"></DatePicker>
        </div>
        <div class="input-item">
          <span class="label">费用类型</span>
          <Select v-model="searchParams.commissionType" clearable>
            <Option value="1">基础费用</Option>
            <Option value="2">限时加费活动</Option>
          </Select>
        </div>
        <div class="input-item">
          <span class="label">险种分类</span>
          <Select v-model="searchParams.themeIds" clearable filterable multiple>
            <Option v-for="(item, index) in themeList" :value="item.id" :key="index">{{ item.name }}</Option>
          </Select>
        </div>
        <div class="input-item">
          <span class="label">出单机构/团队</span>
          <selectTree type="1" v-model="searchParams.applyOrgId" @change="selectTreeChangetwo" ref="selectTree">
          </selectTree>
        </div>
        <div class="input-item">
          <span class="label">出单业务员</span>
          <Select clearable v-model="searchParams.salesmanId" style="width:256px;" filterable :transfer="true">
            <Option :value="item.id" v-for="(item, index) in salesmanList" :key="index"
              :label="item.staffNo + (item.staffNo ? '/' : '') + item.name"></Option>
          </Select>
        </div>
        <div class="input-item" v-if="typeIndex == '1'" key="receivableStatus">
          <span class="label">回款状态</span>
          <RadioGroup v-model="searchParams.receivableStatus" @on-change="searchFun()">
            <Radio label="">全部</Radio>
            <Radio label="1">已回款</Radio>
            <Radio label="0">未回款</Radio>
          </RadioGroup>
        </div>
        <div class="input-item" v-if="typeIndex == '1'" key="payStatus">
          <span class="label">付款状态</span>
          <RadioGroup v-model="searchParams.payStatus" @on-change="searchFun()">
            <Radio label="">全部</Radio>
            <Radio label="1">已付款
              <span class="tip-icon">?</span>
              <div class="pop-tip">
                <span>代收的保费是否已付款给供应商</span>
                <div class="arrow"></div>
              </div>
            </Radio>
            <Radio label="0">未付款</Radio>
          </RadioGroup>
        </div>
        <div class="input-item">
          <span class="label">是否扣款记录</span>
          <RadioGroup v-model="searchParams.queryDeduct" @on-change="searchFun()">
            <Radio label="">全部</Radio>
            <Radio label="1">是</Radio>
            <Radio label="0">否</Radio>
          </RadioGroup>
        </div>
        <div class="input-item">
          <span class="label">业务类别</span>
          <Select v-model="searchParams.sellType" :transfer="true" clearable :disabled="searchParams.sellTypeNull">
            <Option value="1">网销</Option>
            <!-- <Option value="2">电销</Option> -->
            <Option value="3">经代</Option>
          </Select>
          <Checkbox v-model="searchParams.sellTypeNull" class="null" @on-change="changeTypeNull">为空</Checkbox>
        </div>
        <div class="btn-item">
          <Button type="primary" @click="searchFun()">搜索</Button>
          <Button type="primary" ghost @click="reset()">重置</Button>
          <Button type="primary" ghost v-if="searchMore" @click="searchMore = false">收起
            <Icon type="ios-arrow-up" />
          </Button>
          <Button type="primary" ghost v-else @click="searchMore = true">展开
            <Icon type="ios-arrow-down" />
          </Button>
        </div>
      </div>

      <div>
        <typeIndex ref="typeIndex" @toggleBar="toggleBar" @changeTabsBtn="changeTabsBtn" @exportForm="exportForm">
        </typeIndex>
      </div>
    </div>
  </div>
</template>
<script>
import selectTree from "@/components/system/selectTree3";
import { mapState } from "vuex";
import { pageTool } from "@/api/mixins";
import filter from "@/api/filter";
import typeIndex from "./typeIndex.vue";
import lzDicSelect from "@/components/commons/lzDicSelect";
export default {
  mixins: [pageTool],
  data: () => ({
    supplierList: [],
    commissionLists: [],
    salesmanList: [],//所属业务员
    queryList:[],
    themeList: [],
    settleLoading: false,
    searchParams: {
      dateType: '3',
      dateType1:'1'
    },
    settlementForm: {
      checkDate: "", // 结算日期
      checkId: "",
      type: "2",
    }, // 结算
    settlementFormRules: {
      checkId: [
        {
          required: true,
          message: "请选择我司批次",
          trigger: "change",
        },
      ],
      checkDate: [
        {
          required: true,
          message: "请选择结算日期",
          type: "date",
          trigger: "change",
        },
      ],
    },
    batchList: [], // 结算批次列表
    checkStatus: "", // 1 已结算;0 未结算
    selectTreeId: "",
    addbatchVisible: false,
    addbatchForm: {},
    timeArray: [], // 承保时间
    value: "",
    type: "", // 1首年;2续期
    tabModel: "1",
    tableData: [],
    sourceList: [],
    columns: [
      {
        title: "出单机构",
        align: "center",
        key: "orgName",
        minWidth: 200,
      },
      {
        title: "所属团队",
        align: "center",
        minWidth: 160,
        render(h, params) {
          if (!params.row.groupName) {
            return h("div", {}, "-");
          } else {
            return h("div", {}, params.row.groupName);
          }
        },
      },
      {
        title: "业务员姓名",
        align: "center",
        key: "salesmanName",
        minWidth: 160,
        tooltip: true,
      },
      {
        title: "保单号",
        align: "center",
        key: "policyNo",
        minWidth: 200,
        tooltip: true,
      },
      {
        title: "投保人姓名",
        align: "center",
        key: "holderName",
        minWidth: 120,
        tooltip: true,
      },
      {
        title: "被保人姓名",
        align: "center",
        key: "insuranceName",
        minWidth: 120,
        tooltip: true,
      },
      {
        title: "产品名称",
        align: "center",
        key: "productName",
        minWidth: 200,
      },
      {
        title: "附加险名称",
        align: "center",
        minWidth: 200,
        render(h, params) {
          if (!params.row.additionName) {
            return h("div", {}, "-");
          } else {
            return h("div", {}, params.row.additionName);
          }
        },
      },
      {
        title: "保费",
        align: "center",
        key: "fee",
        minWidth: 140,
        tooltip: true,
      },
      {
        title: "费用",
        align: "center",
        key: "commissionPrice",
        minWidth: 140,
        tooltip: true,
      },
      {
        title: "费率",
        align: "center",
        key: "commission",
        minWidth: 100,
        tooltip: true,
      },
      {
        title: "保单状态",
        align: "center",
        minWidth: 100,
        tooltip: true,
        render(h, params) {
          const status = params.row.status;
          if (status == 1) {
            return <span>已承保</span>;
          } else if (status == -1) {
            return <span>已退保</span>;
          } else if (status == 0) {
            return <span>已终止</span>;
          }
        },
      },
      {
        title: "回访状态",
        align: "center",
        minWidth: 100,
        tooltip: true,
        render(h, params) {
          const verifyStatus = params.row.verifyStatus;
          if (verifyStatus === 0 || verifyStatus === "0") {
            return <span>等待回访</span>;
          } else if (verifyStatus == 1) {
            return <span>回访成功</span>;
          } else if (verifyStatus == 2) {
            return <span>回访失败</span>;
          } else if (verifyStatus == 3) {
            return <span>无需回访</span>;
          } else {
            return <span>-</span>;
          }
        },
      },
      {
        title: "保障期",
        align: "center",
        key: "guaranteeValueDesc",
        minWidth: 120,
        tooltip: true,
      },
      {
        title: "交费期",
        align: "center",
        key: "payValueDesc",
        minWidth: 120,
        tooltip: true,
      },
      {
        title: "犹豫期",
        align: "center",
        key: "hesitateDate",
        minWidth: 120,
        tooltip: true,
        render(h, params) {
          const value = filter.filterTime(
            params.row.hesitateDate,
            "YYYY-MM-DD"
          );
          return <span>{value}</span>;
        },
      },
      {
        title: "承保时间",
        align: "center",
        key: "payTime",
        minWidth: 120,
        tooltip: true,
        render(h, params) {
          const value = filter.filterTime(params.row.payTime, "YYYY-MM-DD");
          return <span>{value}</span>;
        },
      },
      {
        title: "操作",
        slot: "action",
        align: "center",
        width: 100,
        fixed: "right",
      },
    ],
    addFormRules: {
      checkDate: [
        {
          required: true,
          message: "请选择结算日期",
          type: "date",
          trigger: "change",
        },
      ],
      checkId: [
        {
          required: true,
          message: "请选择批次",
          trigger: "change",
        },
      ],
    },
    addForm: {
      amount: "", //总保费
      billNum: "", //发票号
      checkAmount: "", //总核收金额
      checkDate: "", //核收日期
      checkType: "", //1首年核收  2、预收
      checkUser: "", //核收人
      commissionIdList: [],
      consultRemark: "", //描述
      num: "", //数量
      type: "1", //1、多条 2、单条选择
      checkId: "", //总批次id
    },
    addVisible: false,
    btnLoading: false,
    tableLoading: false,
    companyLists: [], //保险公司列表
    selectTreeIdShow: true,
    selectTreeIdtwoShow: false,
    typeIndex: 1,
    cur: 0
  }),
  components: { selectTree, typeIndex, lzDicSelect },
  computed: {
    ...mapState({
      companyList: "companyListEntity", //保险公司
      userInfo: "userInfo",
      // themeList: 'themeListEntity', //产品分类
    }),
  },
  activated(){
    
  },
  created() {
    this.$root.$children[0].isShowLoading = false;
    this.type = 1;
    this.searchParams.reconciliationType = 1;
    // 1首年费用记录; 2续期费用记录
    if(!this.$units.superviseShowVal()) {
      this.searchParams.supplierType = '1';
    }
    
    this.getqueryList()
    this.getSource();
    this.getOrganizationUser(null)
    this.queryTheme();
    this.geCompanyList();
    this.searchFun()
  },
  methods: {
    changeValue(value){
      this.searchParams[value] = this.searchParams[value].replace(/^0(0+)|[^\d]+/g, '')
      this.searchParams[value] = this.searchParams[value] && Number(this.searchParams[value])
      return this.searchParams[value]
    },
    // 通过机构获取业务员
    getqueryList() {
      this.$http({
        url: `/buz/commissionReconciliation/queryList`,
        type: "POST",
        data: {
          reconciliationType:'1',
          policyType:1  //policyType，保单类型 1个险 2团险
        }
      }).then((res) => {
        this.queryList = res.data;
      })
    },
    reset(){
      this.searchParams = JSON.parse(JSON.stringify(this.searchParamsOrigin));
      this.selectTreeId = '';
      this.searchParams.isFirst='1';
      this.searchParams.dateType='3';
      this.searchParams.dateType1='1';
      this.searchParams.tab=this.$refs.typeIndex.$refs[this.$refs.typeIndex.componentName].$refs.tabs.brokerageType;
      this.$refs.typeIndex.$refs[this.$refs.typeIndex.componentName].$refs.tabs.searchAjax();
    },
    setReqParams(params){
        params.apiPermissionCode = 'offline_9_0';
    },
    //列表保险公司
    geCompanyList() {
      let url = "/buz/insuranceCompany/read/all";
      this.$http({
        url: url,
        type: "POST",
        data: { companyType: "1" }
      }).then((res) => {
        //赠险公司列表初始化
        this.companyLists = res.data;
      });
    },
    // 产品业务分类
    queryTheme() {
      this.$http({
        url: '/buz/commissionReconciliation/queryProductTheme',
        type: 'GET',
        data:{
          type:1
        }
      }).then(res => {
        this.themeList = res.data;
      });
    },
    getSource() {
      this.$http({
        url: "/buz/productBase/getProductSource",
        type: "get",
      }).then((res) => {
        this.sourceList = res.data;
      });
    },
    // 通过机构获取业务员
    getOrganizationUser(id) {
      this.$http({
        url: `/buz/userBase/getByOrgIds`,
        type: "POST",
        data: {
          orgaList: id ? [id] : []
        }
      }).then((res) => {
        this.salesmanList = res.data;
      })
    },
    changeTypeNull(){
      if(this.searchParams.sellTypeNull){
        this.searchParams.sellType=''
        this.searchParams.sellTypeIsNull = '1'
      }else{
        this.searchParams.sellTypeIsNull = ''
      }

      if(this.searchParams.reconciliationNull){
        this.searchParams.reconciliationId = ''
        this.searchParams.reconciliationIdIsNull = '1'
      }else{
        this.searchParams.reconciliationIdIsNull = ''
      }

      if(this.searchParams.receiptStatusNull){
        this.searchParams.receiptStatusList = []
        this.searchParams.receiptStatusIsNull = '1'
      }else{
        this.searchParams.receiptStatusIsNull = ''
      }

      if(this.searchParams.verifyStatusNull){
        this.searchParams.verifyStatusList = []
        this.searchParams.verifyStatusIsNull = '1'
      }else{
        this.searchParams.verifyStatusIsNull = ''
      }
    },
    // 各项日期处理
    changeDateType(){
        this.searchParams.date = []
        this.searchParams.holdTimeStart = '';
        this.searchParams.holdTimeEnd = '';

        this.searchParams.payTimeStart = '';
        this.searchParams.payTimeEnd = '';

        this.searchParams.insureTimeStart = '';
        this.searchParams.insureTimeEnd = '';

        this.searchParams.effectTimeStart = '';
        this.searchParams.effectTimeEnd	 = '';
    },
    changeDateType1(){
        this.searchParams.date1 = []
        this.searchParams.receiptDate2Start = '';
        this.searchParams.receiptDate2End	 = '';

        this.searchParams.receiptDateStart = '';
        this.searchParams.receiptDateEnd	 = '';

        this.changeDateNull()
    },
    changeDateNull(){
      if(this.searchParams.isNull){
        this.searchParams.date1 = []
        if(this.searchParams.dateType1=='1'){
          this.searchParams.receiptDate2Start = ''
          this.searchParams.receiptDate2End	 = ''

          this.searchParams.receiptDateIsNull = ''
          this.searchParams.receiptDate2IsNull = '1'
        }else if(this.searchParams.dateType1=='2'){
          this.searchParams.receiptDateStart = ''
          this.searchParams.receiptDateEnd	 = ''

          this.searchParams.receiptDate2IsNull = ''
          this.searchParams.receiptDateIsNull = '1'
        }
      }else{
        this.searchParams.receiptDate2IsNull = ''
        this.searchParams.receiptDateIsNull = ''
      }

      if(this.searchParams.isNull1){
        this.searchParams.revisitDate = []
        this.searchParams.revisitDateStart = ''
        this.searchParams.revisitDatEnd	 = ''
        this.searchParams.revisitDateIsNull = '1'
      }else{
        this.searchParams.revisitDateIsNull = ''
      }

      if(this.searchParams.isNull2){
        this.searchParams.hesitateDate = []
        this.searchParams.hesitateDateStart = ''
        this.searchParams.hesitateDateEnd	 = ''
        this.searchParams.hesitateDateIsNull = '1'
      }else{
        this.searchParams.hesitateDateIsNull = ''
      }

      if(this.searchParams.isNull3){
        this.searchParams.refundTime = []
        this.searchParams.refundTimeStart = ''
        this.searchParams.refundTimeEnd	 = ''
        this.searchParams.refundTimeIsNull = '1'
      }else{
        this.searchParams.refundTimeIsNull = ''
      }

      if(this.searchParams.isNull4){
        this.searchParams.checkDate = ''
        this.searchParams.checkDateIsNull = '1'
      }else{
        this.searchParams.checkDateIsNull = ''
      }

    },
    changeTime(time) {
      if(this.searchParams.dateType == '1'){
        this.searchParams.holdTimeStart = time[0];
        this.searchParams.holdTimeEnd = time[1];
      }else if(this.searchParams.dateType == '2'){
        this.searchParams.payTimeStart = time[0];
        this.searchParams.payTimeEnd = time[1];
      }else if(this.searchParams.dateType == '3'){
        this.searchParams.insureTimeStart = time[0];
        this.searchParams.insureTimeEnd = time[1];
      }else if(this.searchParams.dateType == '4'){
        this.searchParams.effectTimeStart = time[0];
        this.searchParams.effectTimeEnd	 = time[1];
      }
    },
    changeTime1(time) {
      if(this.searchParams.dateType1 == '1'){
        this.searchParams.receiptDate2Start = time[0];
        this.searchParams.receiptDate2End	 = time[1];
      }else if(this.searchParams.dateType1 == '2'){
        this.searchParams.receiptDateStart = time[0];
        this.searchParams.receiptDateEnd	 = time[1];
      }
    },
    changeTime2(time) {
      this.searchParams.revisitDateStart = time[0];
      this.searchParams.revisitDatEnd	 = time[1];
    },
    changeTime3(time) {
      this.searchParams.hesitateDateStart = time[0];
      this.searchParams.hesitateDateEnd	 = time[1];
    },
    changeTime4(time) {
      this.searchParams.refundTimeStart = time[0];
      this.searchParams.refundTimeEnd	 = time[1];
    },
    // 获取所有批次
    getCheckNo() {
      this.$http({
        url: "/buz/molCommissionCheck/read/allCheckNo",
        type: "POST",
        data: {
          source: '1',
        },
      }).then((res) => {
        this.batchList = res.data;
      });
    },
    // 新增批次
    saveBatch() {
      this.$units.notCloseModal(this);
      this.$refs["addbatchRef"].validate((valid) => {
        if (valid) {
          this.$http({
            url: "/buz/molCommissionCheck/add",
            type: "POST",
            data: {
              checkName: this.addbatchForm.checkName,
              checkDate: this.$units.formatDate(
                this.addbatchForm.checkDate,
                "yyyy-MM-dd"
              ),
              source: "1",
            },
          }).then((res) => {
            if (res.httpCode == 1) {
              this.$Message.success("新增成功");
              this.getCheckNo();
            }
            this.addbatchVisible = false;
          });
        }
      });
    },
    // 选择批次
    selectBatch(formData, id) {
      const data = this.batchList.find((item) => {
        return item.id == id;
      });
      this.$set(formData, "checkDate", data.checkDate);
    },
    selectTreeChangetwo(data) {
      this.searchParams.salesmanId = '';
      if (data.nodeType == 1) {//机构
        this.getOrganizationUser(data.id)
        this.searchParams.policyOrgId = data.id;
        this.searchParams.groupId = "";
      } else if (data.nodeType == 2) {//团队
        this.searchParams.orgId = "";
        this.getGroupUser(data.id)
        this.searchParams.policyOrgId = ""
        this.searchParams.groupId = data.id;
      } else {
        this.searchParams.orgId = "";
        this.searchParams.groupId = "";
        this.salesmanList = [];
        this.searchParams.policyOrgId = ""
      }
      this.$nextTick(() => {
        this.searchParams.salesmanId = ''
      })
    },
    // 通过机构获取业务员
    getGroupUser(id) {
      this.$http({
        url: `/buz/userBase/getByGroup?groupId=${id}`,
        type: "GET",
      }).then((res) => {
        this.salesmanList = res.data;
      })
    },
    setListParams(params) {
      params.checkStatus = this.checkStatus;
      this.$units.delNull(params);
    },
    searchFun() {
      this.$refs.typeIndex.$refs[
        this.$refs.typeIndex.componentName
      ].$refs.tabs.pageNum = 1;
      this.$refs.typeIndex.$refs[
        this.$refs.typeIndex.componentName
      ].$refs.tabs.getList();
    },
    // 切换供应商类型
    changeSupplierType(value) {
      delete this.searchParams.supplierIds;
      this.supplierList = [];
      if(value==1){
        var url = '/buz/insuranceCompany/read/all'
      }else if(value==2) {
        var url = '/buz/insuranceChannel/read/list'
      } else if (!value) {
        this.supplierList = [];
      }
      if (value) {
        this.$http({
          url,
          type: 'POST',
          data: {}
        }).then((res) => {
          this.supplierList = res.data;
        })
      }
      this.searchFun();
    },
    // 导出
    exportForm() {
      if(this.$units.pointAction('offline_7_9_2')){
        let params = this.searchParams;
      params.isFirst = 1;
      this.$root.$children[0].isShowLoading = true;
      params.tab = this.$refs.typeIndex.tab

      params = JSON.parse(JSON.stringify(params))
      if (this.typeIndex == 2) {
        //下级
        params.receivableStatus = params.payStatus
        delete params.payStatus
      }

      this.$http({
        url: "/buz/commissionReconciliation/exportExcel",
        type: "POST",
        data: params,
        responseType: "blob",
        forced: true,
        All: true,
        apiPermissionCode:'offline_9_2'
      })
        .then((res) => {
          this.$root.$children[0].isShowLoading = false;
          // json格式解析
          if (res.data.type == "application/json") {
            const reader = new FileReader();
            reader.onload = () => {
              let resp = JSON.parse(reader.result);
              if (resp) {
                if (resp.httpCode != 1) {
                  this.$Message.error(resp.msg ? resp.msg : "导出失败");
                  return;
                }
              }
            };
            reader.readAsText(res.data);
          } else {
            // blob格式下载
            this.$units.daochu(res);
          }
        })
        .catch((e) => {
          this.$root.$children[0].isShowLoading = false;
        });
      }else{
        this.$Message.error('无权操作，请联系您的上级')
      }

    },
    toggleBar(name) {
        if (name == "myBrokerage") {
          this.typeIndex = "1";
        } else {
          this.typeIndex = "2";
        }
        this.selectTreeIdShow = true;
        this.selectTreeIdtwoShow = false;
    },
    changeTabsBtn(v) {
      this.cur = v;
      this.$nextTick(() => {
        this.$refs.selectTree.openChange(true);
      })
    }
  },
};
</script>
<style lang='scss' scoped>
.content {
  /deep/.titleBox {
    border-bottom: 0 !important;
    padding-top: 0;
  }

  .tip-icon:hover + .pop-tip {
    opacity: 0.9;
    z-index: 9999;
    display: block;
  }
  .null{
    padding-left: 10px;
    line-height: 30px;
    white-space: nowrap;
  }
  .pop-tip {
    position: absolute;
    width: 190px;
    top: -50px;
    display: flex;
    align-items: center;
    text-align: left;
    left: 50%;
    margin-left: -50px;
    padding: 9px 10px;
    display: flex;
    flex-direction: column;
    background-color: #444444;
    display: none;
    border-radius: 4px;

    span {
      font-size: 12px;
      font-weight: 500;
      color: #fff;
    }

    .arrow {
      position: absolute;
      width: 12px;
      height: 12px;
      background-color: #444444;
      opacity: 0.9;
      bottom: -4px;
      left: 74px;
      transform: rotateZ(135deg);
    }
  }

  .search-box {
    /deep/.input-item.select-two.select-two1>:nth-child(1){
      width: 114px!important;
    }
    .input-item {

      .label {
        font-size: 13px;
      }

      /deep/ .ivu-select-selected-value {
        font-size: 13px;
      }

      /deep/ .ivu-input {
        font-size: 13px;
      }

      /deep/ .ivu-radio-wrapper {
        margin-right: 8px;
      }
    }

    .btn-item {
      .ivu-btn {
        font-size: 13px;
      }
    }
  }
}

/deep/ .tip-icon {
  margin-left: 3px;
  width: 15px;
  height: 15px;
  border-radius: 15px;
  background: transparent;
  border: 1px solid #000;
  color: #000;
  display: inline-block;
  text-align: center;
  line-height: 14px;
  font-size: 14px;
  cursor: pointer;
  top: 50%;
}
</style>
<style lang="scss">
.commissionRecordModal {

  .ivu-modal-footer {
    padding-top: 0;
  }

  .page-form {
    .pc-wrap {
      .ivu-form-item-content {
        display: flex;

        button {
          margin-left: 10px;
        }
      }
    }
  }
}
</style>
